export const contingentEllipsisIcon = {
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 5"><path d="M8.5 4a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM14.5 4a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM2.5 4a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" stroke="#799EAE" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  name: 'ellipsis',
};
